// src/components/ItemFilterList.jsx
import { useEffect, useState } from "react";
import { fetchItems } from "../utils/fetchItems";
import useSortedItems from "../hooks/useSortedItems";
import FilteredItemsRenderer from "./FilteredItemsRenderer";

const ItemFilterList = ({ rootId, category, width, toe, heelHeight, itemMaterial }) => {
 const [items, setItems] = useState([]);
 const [totalItemsCount, setTotalItemsCount] = useState(0);

 useEffect(() => {
  const fetchData = async () => {
   const data = await fetchItems();

   let filteredItems = data;
   if (category) {
    filteredItems = filteredItems.filter((item) => item.item_category === category);
   }
   if (width) {
    if (width.includes("-")) {
     const [min, max] = width.split("-");
     filteredItems = filteredItems.filter((item) => item.item_width_e >= min && item.item_width_e <= max);
    } else {
     filteredItems = filteredItems.filter((item) => item.item_width_e === width);
    }
   }
   if (toe) {
    filteredItems = filteredItems.filter((item) => item.item_toe === toe);
   }
   if (heelHeight) {
    if (heelHeight.includes("-")) {
     const [min, max] = heelHeight.split("-");
     filteredItems = filteredItems.filter((item) => item.item_heel_cm >= min && item.item_heel_cm <= max);
    } else {
     filteredItems = filteredItems.filter((item) => item.item_heel_cm === heelHeight);
    }
   }
   if (itemMaterial) {
    filteredItems = filteredItems.filter((item) => item.item_material === itemMaterial);
   }

   //    console.log(`Filtered items for rootId: ${rootId}`, filteredItems); // デバッグメッセージ
   setItems(filteredItems);
   setTotalItemsCount(data.length);
  };

  fetchData();
 }, [rootId, category, width, toe, heelHeight, itemMaterial]);

 const sortedItems = useSortedItems(items);

 return <FilteredItemsRenderer rootId={rootId} items={sortedItems} totalItemsCount={totalItemsCount} />;
};

export default ItemFilterList;
